import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PropertyDetails } from '../models/property-details';
import {UrlBuilderService} from "@feature/common";

@Injectable()
export class PropertyDetailsHttpService {
  constructor(
    private http: HttpClient,
    private urlBuilder: UrlBuilderService)
  { }

  getPropertyDetails(propertyRef: number): Observable<PropertyDetails> {
    const url = this.urlBuilder.getUrl(`property/${propertyRef}/details`);
    return this.http.get<PropertyDetails>(url);
  }
}
